import {
  FilterResearchFormIcaro,
  ResearchFormIcaro,
} from 'civil-status/view-models/research-form-icaro';

export const transformerDeclarationsListFilter = (
  values?: ResearchFormIcaro
): FilterResearchFormIcaro => {
  return {
    // filtri atto
    ospedale: values?.hospital || undefined,
    annoDichiarazione: values?.year || undefined,
    numeroDichiarazione: values?.number || undefined,
    dataDichiarazioneDa: values?.dateDeclarationStart
      ? values?.dateDeclarationStart.toFormat('yyyyMMdd')
      : undefined,
    dataDichiarazioneA: values?.dateDeclarationEnd
      ? values?.dateDeclarationEnd.toFormat('yyyyMMdd')
      : undefined,
    dataOperazioneDa: values?.dateOperationStart
      ? values?.dateOperationStart.toFormat('yyyyMMdd')
      : undefined,
    dataOperazioneA: values?.dateOperationEnd
      ? values?.dateOperationEnd.toFormat('yyyyMMdd')
      : undefined,
    attoNascita: values?.numberAct || undefined,
    stato: values?.state || undefined,
    // filtri persona
    soggetto: values?.typePerson || undefined,
    cognome: values?.surname || undefined,
    tipoRicercaCognome:
      values?.surname && values?.surnameOperation ? values?.surnameOperation : undefined,
    tipoRicercaNome: values?.name && values?.nameOperation ? values?.nameOperation : undefined,
    nome: values?.name || undefined,
    dataNascita: values?.dateBorn ? values?.dateBorn.toFormat('yyyyMMdd') : undefined,
  };
};
